<template>
  <div>
    <div class="banner" id="banner">
      <div class="banner-container"></div>
    </div>

    <div class="banner_box_media">
      <div class="banner_center_media">
        <div class="media_title">
          {{ $t("group.coopGroup") }}
          <div class="pl90">
            <div>
              {{ $t("group.coopGroup_") }}
            </div>
          </div>
        </div>

        <div class="offline_store">
          <div class="offline_store_font">
            {{ $t("group.content1") }}
          </div>
          <div class="offline_store_font mb29">
            {{ $t("group.content2") }}
          </div>
          <div class="channel_tuan_widthHeight mb27">
            <img src="../../../public/static/img/channel/tuan.png" alt="" />
          </div>
          <div class="group_buying">{{ $t("group.live") }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "index"
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.banner .banner-container {
  padding-top: 86px;
  min-height: 638px;
  background-image: url("http://travelmall.portus.cn/2023/04/ca55ac69cf3e4a75be669cd828e1b382.png");
  background-repeat: no-repeat center;
  background-size: 100% 100%;
}
</style>